export let round = (n: number, p = 2) => (e => Math.round(n * e) / e)(Math.pow(10, p))